module.exports = __webpack_public_path__ + "static/img/yd2.1da7e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd2.jpg
// module id = Aaj1
// module chunks = 63